export default __webpack_public_path__ + "static/sa-d9cbb193a46264d861bff476c544ed06.jpg";